// ─── Types ────────────────────────────────────────────────────
export type ValidationType = "range" | "constant" | "equal" | "enumMatch" | "allElementsInArraySatisfy";

export type ArrayValidationMode = "all" | "indexed";

export interface ValidationRule {
  type: ValidationType;
  min: string;
  max: string;
  value: string;
}

export interface TmState {
  checkedParams: string[];
  validations: Record<string, ValidationRule>;
  arrayModes?: Record<string, ArrayValidationMode>;
  arrayGroups?: Record<string, {
    basePath: string;
    itemType: "primitive" | "object";
    objectFields: string[];
    indices: number[];
  }>;
}

export interface TelemetryPayload {
  [key: string]: unknown;
}

export interface PayloadSchemaProperty {
  type: "integer" | "number" | "string" | "boolean" | "array" | "object";
  minimum?: number;
  maximum?: number;
  description?: string;
  enumMapping?: Record<string, string>;
  properties?: Record<string, PayloadSchemaProperty>;
  items?: {
    type?: string;
    enumMapping?: Record<string, string>;
    properties?: Record<string, PayloadSchemaProperty>;
  };
}

export interface PayloadSchema {
  type: "object";
  properties: Record<string, PayloadSchemaProperty>;
}

export interface TelemetryEntry {
  commandId: number;
  saId: number;
  daId: number;
  subsystem: string;
  commandName: string;
  payload: TelemetryPayload;
  payloadSchema: PayloadSchema;
  mode?: number | null;
}

export interface TelemetryApiResponse {
  status: number;
  message: string;
  data: TelemetryEntry[];
}

export interface TestCaseStep {
  subsystem: { label: string; value: unknown } | null;
  teleData: { label: string; value: unknown } | null;
  delay: string;
  timeout: string;
  tcJson: string;
  validationRule: ValidationRuleEntry[];
  isCritical?: boolean;
}

export interface ValidationRuleEntry {
  label: string;
  value: TelemetryEntry;
  validation: Record<string, unknown>;
}

export const VALIDATION_OPTIONS: { value: ValidationType; label: string }[] = [
  { value: "range", label: "Range" },
  { value: "constant", label: "Constant" },
  { value: "equal", label: "Equal to" },
  { value: "enumMatch", label: "Range" },
];

